import {
  ADD_SCHOR_VERTICAL,
  EDIT_SCHOR_VERTICAL,
  LIST_SCHOR_VERTICAL,
  VIEW_SCHOR_VERTICAL,
  DELETE_SCHOR_VERTICAL,
  ADD_SCHOR_VERTICAL_TEXT,
  EDIT_SCHOR_VERTICAL_TEXT,
  LIST_SCHOR_VERTICAL_TEXT,
  VIEW_SCHOR_VERTICAL_TEXT,
  DELETE_SCHOR_VERTICAL_TEXT,
  SCHOR_VERTICAL_SUCCESS,
  SCHOR_VERTICAL_ERROR,
} from "./actionTypes"

const initialState = {
  successMsg: null,
  error: null,
  editLoading:false
}

const schorVertical = (state = initialState, action) => {
  switch (action.type) {

    // add schor horizontal
    case ADD_SCHOR_VERTICAL:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case SCHOR_VERTICAL_SUCCESS:
      state = {
        ...state,
        loading: false,
        editLoading:false,
        successMsg: action.payload,
      }
      break
    case SCHOR_VERTICAL_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit schor horizontal
    case EDIT_SCHOR_VERTICAL:
      state = {
        ...state,
        editLoading: true,
        
        successMsg: null,
        error: null,
      }
      break

    // list schor horizontal
    case LIST_SCHOR_VERTICAL:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view schor horizontal
    case VIEW_SCHOR_VERTICAL:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete schor horizontal
    case DELETE_SCHOR_VERTICAL:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // text
    // add schor horizontal
    case ADD_SCHOR_VERTICAL_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break
    case SCHOR_VERTICAL_SUCCESS:
      state = {
        ...state,
        loading: false,
        successMsg: action.payload,
      }
      break
    case SCHOR_VERTICAL_ERROR:
      state = { ...state, error: action.payload, loading: false,editLoading:false }
      break

    // edit schor horizontal
    case EDIT_SCHOR_VERTICAL_TEXT:
      state = {
        ...state,
        editLoading: true,
        successMsg: null,
        error: null,
      }
      break

    // list schor horizontal
    case LIST_SCHOR_VERTICAL_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    // view schor horizontal
    case VIEW_SCHOR_VERTICAL_TEXT:
      state = {
        ...state,
        successMsg: null,
        error: null,
      }
      break

    // delete schor horizontal
    case DELETE_SCHOR_VERTICAL_TEXT:
      state = {
        ...state,
        loading: true,
        successMsg: null,
        error: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default schorVertical
